/**
 * Aviso al asesor cuando recibe un caso: sonido corto (sin archivos de audio)
 * y notificación del navegador si la pestaña no está a la vista.
 */
let audioCtx = null;

export function playBeep() {
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    // Dos tonos cortos
    [0, 0.18].forEach((delay, i) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.frequency.value = i === 0 ? 880 : 1175;
      gain.gain.setValueAtTime(0.0001, audioCtx.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(0.2, audioCtx.currentTime + delay + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + delay + 0.15);
      osc.connect(gain).connect(audioCtx.destination);
      osc.start(audioCtx.currentTime + delay);
      osc.stop(audioCtx.currentTime + delay + 0.16);
    });
  } catch {
    // Sin audio (navegador sin permiso de reproducción): el aviso visual basta
  }
}

/** Pide permiso de notificaciones (llamar desde una acción del usuario o al cargar). */
export function requestNotificationPermission() {
  try {
    if ('Notification' in window && Notification.permission === 'default') Notification.requestPermission();
  } catch {}
}

export function notifyNewCase(title, body) {
  playBeep();
  try {
    if ('Notification' in window && Notification.permission === 'granted' && document.hidden) {
      new Notification(title, { body });
    }
  } catch {}
}

let lastReplyBeep = 0;

/**
 * El cliente respondió en un caso del asesor (como WhatsApp): sonido (uno cada
 * 2 s como máximo en una ráfaga) y notificación del sistema si el portal no
 * tiene el foco. Una notificación por chat (`tag`): la nueva reemplaza a la
 * anterior. Al hacer clic se trae el portal al frente y se abre el chat.
 */
export function notifyReply(tag, title, body, onClick) {
  if (Date.now() - lastReplyBeep > 2000) {
    lastReplyBeep = Date.now();
    playBeep();
  }
  try {
    if ('Notification' in window && Notification.permission === 'granted' && (document.hidden || !document.hasFocus())) {
      const n = new Notification(title, { body, tag, renotify: true });
      n.onclick = () => { window.focus(); onClick?.(); n.close(); };
    }
  } catch {}
}
